import { colors } from './modules/colors';
import { breakpoints } from './modules/breakpoints';
import { layers } from './modules/layers';
import { radius } from './modules/radius';
import { Shadows } from './modules/shadows';
import { sizes } from './modules/sizes';
import { text, common } from './modules/text';

export { getTextStyles } from './utils';

export const theme = {
  ...common,
  breakpoints,
  colors,
  layers,
  radius,
  shadows: Shadows,
  sizes,
  text,
};
